<template>
  <div>
    <div class="banner marginBottom40"
         style="padding-top: 72px">
      <div class="EC_width bannerContent">
        <span class="fixedSign"><img src="/image/quanke/oragtou.png"
               class="signBg"><span>智库专家</span></span>
        <div class="display_flex">
          <div class="leftBan">
            <img :src="apiData.banner.headImg">
          </div>
          <div class="rightBan">
            <p class="titleBan">{{apiData.banner.name}}</p>
            <p class="signbar">{{apiData.banner.sign}} / {{apiData.banner.introTitle}}</p>
            <p class="contentText">
              {{apiData.banner.intro}}
            </p>
          </div>
        </div>
      </div>
      <div class="blockD">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold"
             style="font-size: 30px;">
          学术成就
        </div>
      </div>
    </div>
    <div class="positionBtn EC_width"
         style="padding-bottom: 60px;">
      <swiper :options="swiperOption1"
              ref="mySwiper">
        <swiper-slide v-for="(item,index) in timeline"
                      :key="index">
          <div class="timelineWrap">
            <div class="topTime">
              <div class="timeBlock"
                   v-if="item[0]">
                <p class="fontsize22 fontBold">{{item[0].year}}</p>
                <p class="marginTop10">{{item[0].intro}}</p>
              </div>
              <div class="timeBlock"
                   v-if="item[2]">
                <p class="fontsize22 fontBold">{{item[2].year}}</p>
                <p class="marginTop10">{{item[2].intro}}</p>
              </div>
              <div class="timeBlock"
                   v-if="item[4]">
                <p class="fontsize22 fontBold">{{item[4].year}}</p>
                <p class="marginTop10">{{item[4].intro}}</p>
              </div>
            </div>
            <div class="lineBar">
              <img src="/image/english/activeorigin.png"
                   v-for="(itemX,indexX) in item.length"
                   :id="itemX"
                   :key="indexX"
                   class="imgorical">
            </div>
            <div class="topTime">
              <div class="timeBlock"
                   v-if="item[1]"
                   style="margin-left: 260px;">
                <p class="fontsize22 fontBold">{{item[1].year}}</p>
                <p class="marginTop10">{{item[1].intro}}。</p>
              </div>
              <div class="timeBlock"
                   v-if="item[3]">
                <p class="fontsize22 fontBold">{{item[3].year}}</p>
                <p class="marginTop10">{{item[3].intro}}。</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="prevbutton">&lt;</div>
      <div class="nextbutton">&gt;</div>
    </div>
    <div class="grayBg">
      <div class="EC_width">
        <div class="gl_title_vertical_line gl_title_v_line_active"
             style="font-size: 24px;font-weight: bold;">
          学术论文
        </div>
        <div class="display_flex">
          <div class="leftCanvas">
            <img src="/image/quanke/oracl.png">
            <span>论文著作</span>
            <span class="normalColor fontsize22">217</span>
            <span class="normalColor">篇/本</span>
          </div>
          <div class="rightList">
            <div class="marginBottom30"
                 v-for="(item,index) in apiData.learning.list"
                 :key="index">
              <p class="normalColor fontsize16 marginBottom10">{{item.name}}</p>
              <div class="gl_title_vertical_line gl_title_v_line_active fontBold fontsize22 marginBottom10">
                {{item.title}}
              </div>
              <p>{{item.year}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 60px 0;">
      <div class="EC_width">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">课程推荐</span>
            <a href="javascript:;"
               class="gl_pad_btn gl_pad_btn_active marginLeft10">全部</a>
            <a href="javascript:;"
               class="gl_pad_btn marginLeft10">单课程</a>
            <a href="javascript:;"
               class="gl_pad_btn marginLeft10">专栏</a>
            <a href="javascript:;"
               class="gl_pad_btn marginLeft10">大专栏</a>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;"
               class="gl_tb_right_more"><img src="/image/index/moreimg.png"
                   class="gltb_moreimg">更多课程</a>
          </div>
        </div>
      </div>
      <div class="positionBtn EC_width"
           style="padding-bottom: 60px;">
        <swiper :options="swiperOption2"
                ref="mySwiper">
          <swiper-slide v-for="(item,index) in apiData.course.data"
                        :key="index">
            <div class="pub_square">
              <div class="pubs_img">
                <img :src="item.img">
              </div>
              <div class="pubs_body">
                <div class="pubs_title">
                  {{item.title}}
                </div>
                <div class="pubs_label display_between">
                  <div>
                    <span v-for="(itemn,indexn) in item.sign"
                          :key="indexn">{{itemn}}</span>
                  </div>
                  <div class="pubs_cancel">
                    取消收藏
                  </div>
                </div>
                <div class="display_between">
                  <div class="pubs_tip">
                    <span class="redColor">{{item.price}}</span>
                  </div>
                  <div class="pubs_rentou">
                    <img src="/image/geren/ren.png">{{item.num}}人
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="prevbutton2">&lt;</div>
        <div class="nextbutton2">&gt;</div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "qkExpertDetail",
  data () {
    return {
      apiData: {},
      timeline: [],
      swiperOption1: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
        },
      },
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
      }
    }
  },
  created () {
    this.getData()

  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        var usedata = data.qkExpertDetail.timeline.data;
        that.timeline = lodash.chunk(usedata, 5);
        that.apiData = data.qkExpertDetail
      })
    },
  }
}
</script>

<style scoped>
/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 35%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.nextbutton2,
.prevbutton2 {
    top: 40%;
}
.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}
.banner {
    height: 525px;
    background: url(/image/quanke/bg2new.png) center no-repeat;
    background-size: cover;
}
.leftBan {
    left: 195px;
}
.bannerContent {
    position: relative;
}
.fixedSign {
    font-size: 24px;
    color: #fff;
    position: absolute;
    right: 0;
    top: -30px;
}
.fixedSign img {
    vertical-align: -12px;
    margin-right: 6px;
}

.rightBan {
    flex: 1;
    margin-left: 40px;
}
.titleBan {
    font-size: 30px;
    color: #fff;
    font-weight: bold;
}
.signbar {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    margin-top: 23px;
    padding-bottom: 22px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.contentText {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 34px;
    padding-top: 10px;
    text-indent: 2em;
}
.blockD {
    box-sizing: border-box;
    padding-top: 35px;
    padding-left: 45px;
    padding-right: 45px;
    background: #fff;
    width: 1240px;
    position: absolute;
    bottom: 0;
    left: 330px;
}
.banner {
    position: relative;
}
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
}
.timelineWrap {
    height: 300px;
}
.timeBlock {
    height: 140px;
    width: 240px;
    box-sizing: border-box;
    padding-left: 20px;
    padding-top: 10px;
    border-left: 1px dotted #9d9d9d;
    margin-left: 28px;
    display: inline-block;
}
.timeBlock ~ .timeBlock {
    margin-left: 220px;
}
.lineBar {
    background: #0b8586;
    height: 1px;
}
.swiper-slide {
}
.imgorical {
    position: relative;
    z-index: 10;
    top: -9px;
    margin-left: 210px;
}
.imgorical:first-child {
    margin-left: 20px;
}
.grayBg {
    background: #f6f7fb;
    padding: 60px 0;
}
.leftCanvas {
    flex: 1;
}
.rightList {
    width: 516px;
    height: 340px;
    overflow: auto;
    margin-left: 60px;
}
.rightList::-webkit-scrollbar {
    width: 5px;
    background: transparent;
}

/* 滚动槽 */
.rightList::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.rightList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}

.rightList::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
</style>
